
        import '/home/builduser/work/c1dd1064fea009a6/santa-editor/packages/jiraIssueCollector/components/JiraIssueCollectorButton.scss.css.virtualfile';
        module.exports = {"root":"_root_xr6bn_1","button":"_button_xr6bn_13","closeButton":"_closeButton_xr6bn_18","text":"_text_xr6bn_22"};